import { render } from "./SetupForm.vue?vue&type=template&id=db0d8bc2&ts=true"
import script from "./SetupForm.vue?vue&type=script&lang=ts"
export * from "./SetupForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__